// Lightweight, framework-free validators used by consultation & booking forms.
// Each rule returns an error string or null.

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
// Accepts optional +, spaces, dashes; requires at least 7 digits, max 15 (E.164).
const PHONE_RE = /^\+?[\d][\d\s\-]{6,18}$/;

export const requiredMsg = (label) => `${label} is required.`;

export function validateConsultation(form) {
  const errors = {};
  if (!form.name?.trim()) errors.name = requiredMsg('Name');
  if (!form.phone?.trim()) errors.phone = requiredMsg('Phone number');
  else if (!PHONE_RE.test(form.phone.trim())) errors.phone = 'Enter a valid phone number.';
  if (form.email?.trim() && !EMAIL_RE.test(form.email.trim())) {
    errors.email = 'Enter a valid email address.';
  }
  return errors;
}

export function validateBooking(form) {
  const errors = {};
  if (!form.name?.trim()) errors.name = requiredMsg('Name');
  if (!form.phone?.trim()) errors.phone = requiredMsg('Phone number');
  else if (!PHONE_RE.test(form.phone.trim())) errors.phone = 'Enter a valid phone number.';
  if (form.email?.trim() && !EMAIL_RE.test(form.email.trim())) {
    errors.email = 'Enter a valid email address.';
  }
  return errors;
}

export const hasErrors = (errors) => Object.keys(errors).length > 0;
